import React, { useState } from 'react'

import Menu from '../../../components/globalComponents/headerMenu/menu';
import ContactUs from '../../../components/companyInfoComponents/contactUs/contactUs';
import SocialIcons from '../../../components/globalComponents/socialIcons/socialIcons';
import GradientLine from '../../../components/globalComponents/gradientLine/gradientLine';
import Footer from '../../../components/globalComponents/footer/footer';
import ProductoInfoHeader from '../../../components/productsInfoComponents/productoInfoHeader/productoInfoHeader';
import ProductoInfoCompany from '../../../components/productsInfoComponents/productsInfoCompany/productsInfoCompany';
import PorductsDaroma from '../../../components/productsInfoComponents/porductsDaroma/porductsDaroma';

import './productsinfoPage.scss'

const ProductsInfoPage = () => {
    const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
    return(
        <>
            {/* Overlay controlado globalmente */}
            <Menu isOffcanvasOpen={isOffcanvasOpen} setIsOffcanvasOpen={setIsOffcanvasOpen} />
            <div className=''>
                <ProductoInfoHeader/>
                <ProductoInfoCompany/>
                <PorductsDaroma/>
            </div>
            <ContactUs/>
            <SocialIcons />
            <GradientLine />
            <Footer />
            
        </>
        
    )
}

export default ProductsInfoPage;